/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagesortamount3Inputs */

const en_ticketpagesortamount3 = /** @type {(inputs: Ticketpagesortamount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highest amount`)
};

const de_ticketpagesortamount3 = /** @type {(inputs: Ticketpagesortamount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchster Betrag`)
};

/**
* | output |
* | --- |
* | "Highest amount" |
*
* @param {Ticketpagesortamount3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagesortamount3 = /** @type {((inputs?: Ticketpagesortamount3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagesortamount3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagesortamount3(inputs)
	return de_ticketpagesortamount3(inputs)
});
export { ticketpagesortamount3 as "ticketPageSortAmount" }